import openAboutDialogComponent from './family-plan-about-dialog.component';

export default angular
  .module('fizyweb.paycell.openAbout', [])
  .component('familyPlanAboutDialog', openAboutDialogComponent)
  .name;



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-about-dialog/family-plan-about-dialog.module.ts